import * as React from "react";
import Form from "react-bootstrap/Form";
import Avatar from "../../Assets/images/avatar.png";
import Button from "react-bootstrap/Button";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import Cookies from "js-cookie";
import axios from "axios";
import { BASE_URL } from "../../Landing/Components/Api/Api";
import SweetAlert from "../../Landing/Components/SweetAlert/SweetAlert";
import { Toast } from "primereact/toast";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import TelInput from "../../Landing/Components/FormOptions/TelInput";
import { InputFormat } from "../../Landing/Components/FormOptions/InputFormat";
import { CheckboxFormat } from "../../Landing/Components/FormOptions/CheckboxFormat";
import { Col, Row } from "react-bootstrap";
import DataTableTemplate from "../Components/DataTableTemplate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { PanelContainer } from "../Components/PanelContainer";
import { fetchData } from "../Components/Utilities";
import Swal from "sweetalert2";
import SelectButtonFormat from "../../Landing/Components/FormOptions/SelectButtonFormat";

export const SupportList = () => {
  const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
  const [showEditComponent, setShowEditComponent] = useState(false);
  const [defaultRows, setDefaultRows] = useState(20);
  const [pageData, setPageData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: defaultRows,
  });

  const defaultValues = {
    Name: "",
    Family: "",
    sort: "",
    status: 1,
    Mob: "",
    maxuser: "",
  };
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const schema = yup.object({
    Mob: yup
      .string()
      .required("شماره موبایل وارد نشده است.")
      .min(11, "شماره موبایل نباید کمتر از 11 کاراکتر باشد.")
      .max(11, "شماره موبایل نباید بیش از 11 کاراکتر باشد."),
  });
  const {
    handleSubmit,
    reset,
    control,
    register,
    setValue,
    formState: { errors },
  } = useForm({ defaultValues, resolver: yupResolver(schema) });

  const cols = [
    {
      field: "Mob",
      header: "ردیف",
      body: (data, options) => options.rowIndex + 1,
    },
    {
      field: "Mob",
      header: "نام و نام خانوادگی",
      body: (data, options) => data?.Name + " " + data?.Family,
    },
    {
      field: "maxuser",
      header: "حداکثر",
    },
    { field: "remain", header: " باقی مانده" },
    { field: "Mob", header: ",موبایل" },
    {
      field: "CityName",
      header: "ویرایش",
      body: (data, options) => (
        <div className="my-1">
          <FontAwesomeIcon
            icon={"edit"}
            onClick={() => handleOpeEditItem(data)}
            className="icon-sm prime-bg text-white p-1 text-center rounded"
            color="gray"
          />
        </div>
      ),
    },
  ];

  const onSubmit = async (data) => {
    let status;
    if (data?.Fstatus) {
      status = 1;
    } else {
      status = 0;
    }

    const bodyFormData = new FormData();
    bodyFormData.append("Name", data?.Name);
    bodyFormData.append("Family", data?.Family);
    bodyFormData.append("sort", data?.sort);
    bodyFormData.append("status", status);
    bodyFormData.append("Mob", data?.Mob);
    bodyFormData.append("maxuser", data?.maxuser);

    let cmd = "createsupport";
    if (selectedUserId) {
      bodyFormData.append("groupid", selectedUserId);
      cmd = "updatesupport";
    }
    try {
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: cmd,
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        if (responseGlobal?.data) {
          SweetAlert({
            title: "",
            text: responseGlobal?.data?.msg,
            type: `${responseGlobal.data?.code === 1 ? "success" : "error"}`,
          });
        }
        fetchData("supportlist", bodyFormData, handleApiResponse);
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      throw new Error("Cpanel private route Error: ", error.message);
    }
  };

  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    bodyFormData.append("pageNo", lazyState?.page + 1 ?? 1);
    bodyFormData.append("pageSize", lazyState?.rows ?? 20);
    fetchData("supportlist", bodyFormData, handleApiResponse);
  }, []);
  const handleApiResponse = (data) => {
    setPageData(data?.dt);
    reset({ ...defaultValues, ...data?.dt });
  };
  const handleOpeEditItem = (data) => {
    if (data) {
      setIsEditMode(true);
      setSelectedUserId(data?.catid);
      reset({ ...defaultValues, ...data });
    } else {
      reset(defaultValues);
      setIsEditMode(false);
    }

    setShowEditComponent(true);
    // reset({...defaultValues, ...data})
  };

  const onpage = (event) => {
    setLazyState({
      first: event.first,
      rows: event.rows,
      page: event.page,
    });
    setDefaultRows(event.rows);
  };
  const toast = useRef(null);
  const reject = () => {
    toast.current.show({
      severity: "warn",
      summary: "لغو شد",
      detail: "درخواست حذف لغو شد",
      life: 3000,
    });
  };
  const handleOpeDeleteItem = async (id) => {
    console.log(id);
    const bodyFormData = new FormData();
    bodyFormData.append("fid", id);
    try {
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: "delfeatures",
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        if (responseGlobal?.data?.UserId === "0") {
        }
        toast.current.show({
          severity: "info",
          summary: "تایید شد",
          detail: "درخواست شما انجام شد",
          life: 3000,
        });
        fetchData("supportlist", bodyFormData, handleApiResponse);
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      console.error("Error while fetching menu data:", error);
    }
  };

  const handleDelete = (id) => {
    Swal.fire({
      show: true,
      title: "حذف آیتم منو",
      text: "آیا می خواهید آیتم را حذف کنید؟",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "بله",
      cancelButtonText: "خیر",
      cancelButtonColor: "#d33",
      icon: "success",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await handleOpeDeleteItem(id);
      }
    });
  };
  const stOptions = [
    { label: "فعال", value: 1 },
    { label: "غیرفعال", value: 0 },
  ];
  return (
    <PanelContainer title={"افزودن/ ویرایش حمایت ها"}>
      <div className="row text-right p-md-5 p-sm-0  data-table">
        <Toast ref={toast} />
        <ConfirmDialog />
        <DataTableTemplate
          lazyState={lazyState}
          // select='select'
          className={"table-border"}
          columns={cols}
          list={pageData}
          totalRecords={totalRecords}
          setlazyState={setLazyState}
          setDefaultDatatableRows={setDefaultDatatableRows}
          defaultDatatableRows={defaultDatatableRows}
          width="25rem"
        />
        <div className="col-6">
          <Button className="m-2" onClick={() => handleOpeEditItem()}>
            افزودن
          </Button>
        </div>
      </div>
      {showEditComponent && (
        <Form dir="rtl" onSubmit={handleSubmit(onSubmit)}>
          <div className="panel-heading prime-bg text-white text-center py-2">
            <span id="ContentPlaceHolder1_lblbannerheading ">
              {isEditMode ? "ویرایش حمایت" : "افزودن حمایت جدید"}
            </span>
          </div>
          <div className="panel-body">
            <div className="row d-flex justify-content-between align-items-center ">
              <div className=" col-md-12 mauto nopaddingmob col-xs-9">
                <Row>
                  <Col className=" col-12 col-lg-6">
                    <InputFormat
                      control={control}
                      name="Name"
                      type={"text"}
                      label="نام"
                      errors={errors}
                    />
                  </Col>
                  <Col className=" col-12 col-lg-6">
                    <InputFormat
                      control={control}
                      name="Family"
                      type={"text"}
                      label="نام خانوادگی"
                      errors={errors}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className=" col-12 col-lg-6">
                    <TelInput
                      control={control}
                      name="Mob"
                      type={"tel"}
                      defaultValue={""}
                      maxLength={"11"}
                      label="شماره موبایل"
                      errors={errors}
                      required={true}
                    />
                  </Col>
                  <Col className=" col-12 col-lg-6">
                    <InputFormat
                      control={control}
                      name="maxuser"
                      type={"number"}
                      label="تعداد معرف ها"
                      errors={errors}
                    />
                  </Col>
                </Row>
                <div className="d-flex flex-row align-items-center justify-content-between gap-1">
                  {/* <CheckboxFormat
                    control={control}
                    name="status"
                    errors={errors}
                    type="checkbox"
                    label="وضعیت نمایش"
                  /> */}
                  <div className="d-flex flex-direction-column justify-content-start gap-2">
                    <Form.Label className="fw-bold pb-1">
                      وضعیت نمایش
                    </Form.Label>
                    <SelectButtonFormat
                      name={"status"}
                      options={stOptions}
                      control={control}
                    />
                  </div>
                </div>
                  <Button type="submit">ذخیره</Button>
              </div>
              <div className="d-flex flex-row flex-wrap justify-content-center align-items-center gap-1"></div>
            </div>
          </div>
        </Form>
      )}
    </PanelContainer>
  );
};
